(function () {
  const mqMobile = window.matchMedia("(max-width: 989px)");
  const root = document.documentElement;

  // ✅ SOLO per Safari iOS: disinnesca il layer “momentum scroll” mentre un popup è aperto
  function syncOpenState() {
    if (!mqMobile.matches) return; // non tocchiamo desktop
    document.body.classList.toggle("prFltOpen", !!document.querySelector(".prFlt__pill[open]"));
  }

  function closeAll(except) {
    document.querySelectorAll(".prFlt__pill[open]").forEach((d) => {
      if (except && d === except) return;
      d.removeAttribute("open");
    });
    syncOpenState();
  }

  // ===== posizionamento popup (mobile già fixed da CSS, desktop lo gestiamo uguale) =====
  let lastBtn = null;
  let lastPill = null;

  function positionPop(btn, pill) {
    if (!btn || !pill) return;

    requestAnimationFrame(() => {
      const br = btn.getBoundingClientRect();
      const vw = window.innerWidth;

      const cssW = parseFloat(getComputedStyle(root).getPropertyValue("--prFltPopW")) || 360;
      const W = Math.min(cssW, vw - 24);
      const half = W / 2;

      let center;

      if (mqMobile.matches && pill.classList.contains("prFlt__pill--sort")) {
        // MOBILE: ordina centrato nello schermo
        center = vw / 2;
      } else {
        // altri: centrato sotto al bottone cliccato
        center = br.left + br.width / 2;
      }

      center = Math.max(half + 12, Math.min(center, vw - half - 12));
      const top = br.bottom + 10;

      root.style.setProperty("--prFltPopLeft", center + "px");
      root.style.setProperty("--prFltPopTop", top + "px");
    });
  }

  // ===== DESKTOP: toggle nativo, chiudi gli altri + posiziona =====
  document.addEventListener(
    "toggle",
    (e) => {
      const d = e.target;
      if (!d?.classList?.contains("prFlt__pill")) return;

      if (!mqMobile.matches && d.open) {
        closeAll(d);
        const btn = d.querySelector(".prFlt__pillBtn");
        lastBtn = btn;
        lastPill = d;
        positionPop(btn, d);
      }
    },
    true
  );

  // ===== MOBILE: click singolo forzato (desktop NON si tocca) =====
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".prFlt__pillBtn");
    if (!btn) return;

    const pill = btn.closest(".prFlt__pill");
    if (!pill) return;

    if (!mqMobile.matches) return;

    e.preventDefault();
    e.stopPropagation();

    const wasOpen = pill.hasAttribute("open");
    closeAll();

    if (!wasOpen) {
      pill.setAttribute("open", "");
      syncOpenState(); // ✅ SOLO mobile/iPhone

      lastBtn = btn;
      lastPill = pill;
      positionPop(btn, pill);
    }
  });

  // ===== aggiorna posizione se scroll/resize (solo se qualcosa è aperto) =====
  function refreshIfOpen() {
    const open = document.querySelector(".prFlt__pill[open]");
    if (!open) return;
    positionPop(lastBtn, lastPill);
  }

  window.addEventListener("resize", refreshIfOpen, { passive: true });
  window.addEventListener("scroll", refreshIfOpen, { passive: true });

  // ===== click fuori: chiudi (mobile+desktop) =====
  document.addEventListener("click", (e) => {
    if (e.target.closest(".prFlt")) return;
    if (e.target.closest(".prFlt__pop")) return; // popup cliccabile
    closeAll();
  });

  // ===== SORT (radio) -> submit + aggiorna testo + chiudi =====
  document.addEventListener("click", (e) => {
    const item = e.target.closest(".prFlt__pill--sort .prFlt__item");
    if (!item) return;

    e.preventDefault();
    e.stopPropagation();

    const r = item.querySelector("[data-pr-sort-radio]");
    if (!r) return;

    const sortPill = item.closest(".prFlt__pill--sort");
    sortPill?.querySelectorAll("[data-pr-sort-radio]").forEach((x) => (x.checked = false));
    r.checked = true;

    const sel = document.querySelector("[data-pr-flt-sort]");
    if (sel) {
      sel.value = r.value;
      sel.closest("form")?.submit();
    }

    const lab = item.querySelector(".prFlt__lab")?.textContent?.trim() || "";
    const cur = sortPill?.querySelector("[data-pr-sort-cur]");
    if (cur && lab) cur.textContent = lab;

    sortPill?.removeAttribute("open");
    syncOpenState();
  });

  // ===== RESET singolo filtro =====
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-pr-flt-clear]");
    if (!b) return;

    e.preventDefault();
    e.stopPropagation();

    const keys = (b.getAttribute("data-clear-keys") || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

    const url = new URL(window.location.href);
    keys.forEach((k) => url.searchParams.delete(k));
    url.searchParams.delete("page");
    window.location.href = url.toString();
  });

  // ===== RESET tutti =====
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-pr-flt-reset-all]");
    if (!b) return;

    e.preventDefault();
    e.stopPropagation();

    const url = new URL(window.location.href);
    for (const key of Array.from(url.searchParams.keys())) {
      if (key.startsWith("filter.")) url.searchParams.delete(key);
    }
    url.searchParams.delete("page");
    window.location.href = url.toString();
  });

  // ===== search marca =====
  document.querySelectorAll(".prFlt__pill").forEach((d) => {
    const search = d.querySelector("[data-pr-flt-search]");
    const list = d.querySelector("[data-pr-flt-search-list]");
    if (!search || !list) return;

    const items = Array.from(list.querySelectorAll("[data-pr-flt-item]"));
    search.addEventListener("input", () => {
      const q = (search.value || "").trim().toLowerCase();
      items.forEach((it) => {
        it.style.display = !q || it.innerText.toLowerCase().includes(q) ? "" : "none";
      });
    });
  });
})();
